import { PROJECT_STATUS_LABELS } from '@epasu/core/constants';
import type { ProjectStatus } from '@epasu/core/constants';

/**
 * Status eines Projekts als farbige Pille.
 *
 * An einer Stelle definiert, weil sie in Liste, Board, Kundenakte und
 * Projektakte auftaucht. Von der gleichnamigen Pille der Aufträge getrennt:
 * gemeinsame Farben für zwei unterschiedliche Statuslisten hätten bedeutet,
 * dass „abgeschlossen“ und „abgerechnet“ gleich aussehen.
 */
const PROJECT_STATUS_COLORS: Record<ProjectStatus, string> = {
  planung: 'bg-sky-100 text-sky-800',
  in_arbeit: 'bg-amber-100 text-amber-800',
  wartet_kunde: 'bg-violet-100 text-violet-800',
  abgeschlossen: 'bg-emerald-100 text-emerald-800',
  abgebrochen: 'bg-rose-100 text-rose-800',
};

export function ProjectStatusPill({ status }: { status: ProjectStatus | string }) {
  const klasse =
    PROJECT_STATUS_COLORS[status as ProjectStatus] ?? 'bg-muted text-muted-foreground';
  return (
    <span className={`rounded px-2 py-0.5 text-xs font-medium ${klasse}`}>
      {PROJECT_STATUS_LABELS[status as ProjectStatus] ?? status}
    </span>
  );
}
